var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewAttachedFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13 5.44781 13.4469 5 14 5H17.9719C18.1344 5 18.2656 5.02688 18.3813 5.07594C18.4719 5.12438 18.6094 5.19594 18.7063 5.29062C18.7063 5.29219 18.7063 5.29375 18.7094 5.295C18.9031 5.48937 18.9719 5.74313 19 5.99688C19 5.99813 19 5.99906 19 6V10C19 10.5531 18.5531 11 18 11C17.4469 11 17 10.5531 17 10V8.41563L11.7063 13.7063C11.3156 14.0969 10.6844 14.0969 10.2937 13.7063C9.90312 13.3156 9.90312 12.6844 10.2937 12.2937L15.5844 7H14C13.4469 7 13 6.55219 13 6ZM5 8C5 6.89531 5.89531 6 7 6H10C10.5531 6 11 6.44781 11 7C11 7.55312 10.5531 8 10 8H7V17H16V14C16 13.4469 16.4469 13 17 13C17.5531 13 18 13.4469 18 14V17C18 18.1031 17.1031 19 16 19H7C5.89531 19 5 18.1031 5 17V8Z",
    fill: "#270ADC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAttachedFiles);
export default __webpack_public_path__ + "static/media/ViewAttachedFiles.c017c25aac12388c8cd2b435f6187655.svg";
export { ForwardRef as ReactComponent };